/* eslint-disable camelcase */
import { DeviceType } from '@westwing/appshell_types/appshellMetaTypes';
import buildUrl from 'build-url';

export const URL = 'https://zwyf.adj.st';
export const trackers: Partial<Record<DeviceType, string>> = { IOS: '59s8kng', ANDROID: 'ish46dg' };

export const getSmartAppBannerUrl = (host: string, device: DeviceType): string => {
    const tracker = trackers[device] || '';

    const deepLinkURL = window.location.href;
    const fallbackURL = `${host}/m/app/`;
    return buildUrl(URL, {
        queryParams: {
            adjust_t: tracker,
            adjust_deeplink: deepLinkURL,
            adjust_fallback: fallbackURL,
        },
    });
};
